import { render, staticRenderFns } from "./kol_manager.vue?vue&type=template&id=747cf3e9&scoped=true"
import script from "./kol_manager.vue?vue&type=script&lang=ts"
export * from "./kol_manager.vue?vue&type=script&lang=ts"
import style0 from "./kol_manager.vue?vue&type=style&index=0&id=747cf3e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747cf3e9",
  null
  
)

export default component.exports